import * as React from "react";
import { useState, useEffect } from "react";
import PropTypes from "prop-types";

import SaveIcon from "@mui/icons-material/Save";

import FormControlLabel from "@mui/material/FormControlLabel";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import DialogContentText from "@mui/material/DialogContentText";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Typography from "@mui/material/Typography";
import Checkbox from "@mui/material/Checkbox";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { TextField, Button, FormControl } from "@mui/material";
import { useSelector } from "react-redux";

import AuditTrailViewService from "../../services/audittrailview.service.js";
import ConfigurationViewService from "../../services/configurationview.service";
import RecipeService from "../../services/recipe.service";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

function BootstrapDialogTitle(props) {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ mr: 4, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}

BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired,
};

//function to remove keys from the each json object of the json Array.
function removeKeyValuesFromObjects(jsonArray, keysToRemove) {
  return jsonArray.map((item) => {
    const updatedObject = { ...item };

    keysToRemove.forEach((keyToRemove) => {
      delete updatedObject[keyToRemove];
    });

    return updatedObject;
  });
}

// Function to check json object is present in json array or not
function isObjectInArray(jsonArray, targetObject) {
  return jsonArray.some((item) => {
    for (const key in targetObject) {
      if (targetObject.hasOwnProperty(key) && item[key] !== targetObject[key]) {
        return false;
      }
    }
    return true;
  });
}

// Check blank values inside the row data
function hasBlankOrNullValues(obj) {
  for (const key in obj) {
    const value = obj[key];
    if (value === null || value === "") {
      return true; // Found a blank or null value
    }

    if (typeof value === "object" && hasBlankOrNullValues(value)) {
      return true; // Recursively check nested objects
    }
  }

  return false; // No blank or null values found
}

// Function to create auditTrailData
const createAuditTrailData = (
  oldValues,
  newValues,
  tagName,
  activity,
  activityType,
  userName,
  role,
  remark,
  eventStatus,
  widgetName,
) => {
  let auditTrailData = [];
  // Get the keys of the oldValues
  const keys1 = Object.keys(oldValues);
  //console.log(keys1)
  //console.log(Object.keys(newValues))
  //console.log(keys1.length, Object.keys(newValues).length)
  // Check if the number of keys is the same
  if (keys1.length !== Object.keys(newValues).length) {
    return auditTrailData;
  } else {
    // Iterate over the keys of the oldValues
    for (let key of keys1) {
      //console.log(key, oldValues[key], newValues[key]);

      let activityStatus = activity;
      // modify Activity if event is enabled else activity will be deafualt value received form audittrail config collection
      if (eventStatus === "Enabled") {
        if (key === "TagName") {
          activityStatus = `Added new parameter - '${tagName}' to the recipe - '${widgetName}'`;
          auditTrailData.push({
            TimeStamp: new Date(),
            Activity: activityStatus,
            ActivityType: activityType,
            UserName: userName,
            Role: role,
            Remark: remark,
            EventStatus: eventStatus,
          });
        }
      } else {
        if (key === "TagName") {
          auditTrailData.push({
            TimeStamp: new Date(),
            Activity: activityStatus,
            ActivityType: activityType,
            UserName: userName,
            Role: role,
            Remark: remark,
            EventStatus: eventStatus,
          });
        }
      }
    }
    return auditTrailData;
  }
};

function SaveChangesDialog(props) {
  const [open, setOpen] = useState(false);

  const [auditTrailData, setAuditTrailData] = React.useState([]); // AuditTrail Data

  const [openRemarkBlnkMsg, setOpenRemarkBlnkMsg] = useState(false);
  const [password, setPassword] = useState("");

  const handleClickOpen = () => {
    if (
      (props.rowData.RemarkStatus === "Enabled" &&
        props.auditTrailRemark === "--") ||
      (props.rowData.RemarkStatus === "Enabled" &&
        props.auditTrailRemark === "")
    ) {
      setOpenRemarkBlnkMsg(true);
      //console.log("Enter or change the Remark value to proceed further")
    } else {
      setOpen(true);
    }
  };

  const handleClose = () => {
    setOpen(false);
    setOpenRemarkBlnkMsg(false);
  };

  const handleSuccessClose = () => {
    setOpenSuccessDialog(false);
    props.success(true);
  };

  const handleFildClose = () => {
    setOpenFaildialog(false);
  };

  const [message, setMessage] = useState();

  const [openSuccessDialog, setOpenSuccessDialog] = useState(false);
  const [openFaildialog, setOpenFaildialog] = useState(false);

  const [saveData, setSaveData] = useState(false);
  const handleClickSaveChanges = () => {
    let oldValues = props.oldValues;
    let newValues = props.newValues;
    let tagName = props.tagName;
    let activity = props.activity;
    let activityType = "Add Parameter To Recipe";
    let userName = props.email;
    let role = props.role;
    let remark = props.auditTrailRemark;
    let eventStatus = props.configData.EventStatus;

    let widgetName = props.rowData.WidgetName;

    let auditTrailData = createAuditTrailData(
      oldValues,
      newValues,
      tagName,
      activity,
      activityType,
      userName,
      role,
      remark,
      eventStatus,
      widgetName,
    );
    //console.log(auditTrailData)
    setAuditTrailData(auditTrailData);
    setSaveData(true);
  };

  //Get Application Configuration data
  useEffect(() => {
    async function getColumnData() {
      try {
        let dashboardName = "ApplicationConfig";
        const response =
          await ConfigurationViewService.getAllRowsData(dashboardName);

        if (response.data.length > 0) {
          //setPwdInterlock(response.data[9].TaskStatus);
          //console.log(response.data[9].TaskStatus);
        }
      } catch (error) {
        console.log(error);
      }
    }
    getColumnData();
  }, []);

  // Add new row to collection
  useEffect(() => {
    async function saveRowData() {
      try {
        let dashboardName = "RecipeView";
        // Data object excluding the SrNo field initially
        let rowData = {
          ProjectName: props.configData.ProjectName,
          DashboardType: props.configData.DashboardType,
          WidgetName: props.configData.WidgetName,
          ParameterName: props.rowData[0].ParameterName,
          ParameterUnit: props.rowData[0].ParameterUnit,
          RecipeValue: props.rowData[0].RecipeValue,
          TagName: props.rowData[0].TagName,
          EventStatus:props.configData.EventStatus,
          PWDInterlock: props.configData.PWDInterlock,
          PWD: password,
        };
        //let rowData = { ...props.rowData, PWDInterlock: props.configData.PWDInterlock, PWD: password,};

        //console.log(dashboardName, rowData, auditTrailData)
        //console.log(props.rowData)
        //const response =1;
        const response = await RecipeService.createRow( dashboardName, rowData, auditTrailData, ); // Create new record
        if (response) {
          setOpenSuccessDialog(true);
          setMessage("Record Added Successfully");
          setSaveData(false);
          setOpen(false); // Close "Save changes" window
        }

        
      } catch (error) {
        setOpenFaildialog(true);
        setMessage(
          "Error While Adding Record, Please verify all parameters entered in form",
        );
        setOpen(false); // Close "Save changes" window
        console.log(error);
      }
    }

    // Call saveRowData if saveData is true
    if (saveData) {
      saveRowData();
      setSaveData(false);
    }
  }, [saveData]); // Dependency on saveData

  return (
    <div>
      <Button
        variant="outlined"
        startIcon={<SaveIcon />}
        sx={{ mt: 1 }}
        onClick={handleClickOpen}
      >
        SAVE CHANGES{" "}
      </Button>

      {/* Open Remark Field is blank dialog box */}
      <Dialog open={openRemarkBlnkMsg} onClose={handleClose}>
        <DialogTitle>Enter Remark Field</DialogTitle>
        <Box sx={{ width: 450 }}>
          <DialogContent dividers>
            <DialogContentText>
              Enter or change the Remark Field to proceed further.
              <br />
              (Note: '--' Value for remark field is not acceptable)
            </DialogContentText>
          </DialogContent>
        </Box>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
        </DialogActions>
      </Dialog>

      {/* Open Dialog to ask surity to edit user's data, with or withoout password */}
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>SAVE CHANGES</DialogTitle>
        <Box sx={{ width: 400 }}>
          <DialogContent dividers>
            <DialogContentText>
              Are you sure to add the new row?.
            </DialogContentText>
          </DialogContent>

          {props.rowData.PWDInterlock === "Enabled" && (
            <DialogContent dividers>
              <DialogContentText>
                Enter the Password to add new recipe.
              </DialogContentText>
              <TextField
                autoFocus
                margin="dense"
                id="Password"
                label="Password"
                type="password"
                fullWidth
                variant="standard"
                onChange={(event) => {
                  setPassword(event.target.value);
                }}
              />
            </DialogContent>
          )}
        </Box>
        <DialogActions>
          <Button onClick={handleClickSaveChanges}>Save</Button>
          <Button onClick={handleClose}>Cancel</Button>
        </DialogActions>
      </Dialog>

      {/* Success dialog after upgradtion of teh user info. */}
      <Dialog open={openSuccessDialog} onClose={handleSuccessClose}>
        <DialogTitle> success.. </DialogTitle>
        <DialogContent>
          <DialogContentText>{message}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleSuccessClose}>Close</Button>
        </DialogActions>
      </Dialog>

      {/* Save Changes Failed dialog /Wrong Password */}
      <Dialog open={openFaildialog} onClose={handleFildClose}>
        <DialogTitle> Failed.. </DialogTitle>
        <DialogContent>
          <DialogContentText>{message}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleFildClose}>Close</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default function DatalogConfigAdd({ open, close }) {
  const { user } = useSelector((state) => state.auth);
  const projectName = user.selectedproject;
  const dashboardType = "RecipeView";
  const widgetName = useSelector((state) => state.splitbutton1.widgetName);
  const groupName = useSelector( (state) => state.splitbutton12GroupName.groupName);

  //console.log(groupName);
  //console.log(widgetName)
  //const [widgetName, setWidgetname] = useState("")

  const initialTagConfigData = {
    //id: null,
    ProjectName: projectName,
    WidgetName: widgetName,
    DashboardType: dashboardType,

    SrNo: 1,
    TagType: "ModbusTag",
    BlockName: "",
    TagName: "",
    EditEnable: "Disabled",
    email: user.email,
    role: user.role,
    RemarkStatus: "Disabled",
    EventStatus: "Disabled",
    PWDInterlock: "Disabled",
  };

  const [eventDescription, setEventDescription] = useState("--");
  const [auditTrailRemark, setAuditTrailRemark] = useState("--");
  // parameter list for audit trail log
  const oldValues = { TagType: "ModbusTag", BlockName: "", TagName: "" };
  const [newValues, setNewValues] = useState(oldValues);


  const [configData, setConfigData] = React.useState(initialTagConfigData);

  const [recipeParameterListData, setRecipeParameterListData] = React.useState([]);
  const [recipeParameterList, setRecipeParameterList] = React.useState([]);
  const [selectedParameter, setSelectedParameter] = useState("");
  const [parameterNames, setParameterNames] = React.useState([]);

  // Get AuditTrail Configuration data for Remark field, either it is enabled or disabled
  useEffect(() => {
    async function auditTrailConfigData() {
      try {
        let dashboardName = "AuditTrailConfig";
        let columnName = "EventName";
        let columnValue = "Add Parameter To Recipe";
        let response = await AuditTrailViewService.getColumnData(
          dashboardName,
          columnName,
          columnValue,
        );

        //console.log(response.data[0].EnableRemark);
        if (response.data.length > 0) {
          setConfigData({
            ...configData,
            EventStatus: response.data[0].EnableEvent,
            PWDInterlock: response.data[0].EnablePwdInterlock,
            RemarkStatus: response.data[0].EnableRemark,
          });

          setEventDescription(response.data[0].DefaultEventDescription);
          // If remark field is disabled then set default remark vlaue to currrent Remark value
          if (response.data[0].EnableRemark === "Disabled") {
            setAuditTrailRemark(response.data[0].DefaultEventRemark);
          }
        }
      } catch (error) {
        console.log(error);
      }
    }

    auditTrailConfigData();
  }, []);

  // Get ParameterList and data of the selecetd group.
    useEffect(() =>{
      async function getAllColumnData()  {
        try {
  
          // Prepare API parameters
          const dashboardName = "RecipeParameterList";
          const columnsToRetrieve = ["ParameterName", "ParameterUnit", "RecipeValue", "TagName"];
          const columnNameToFilter = "recipegroupnamelist";
          //const valueToMatch = recipeListData['recipegroupnamelist'];
          const valueToMatch = groupName;
          //console.log(widgetName)
          
  
          // Fetch data from Inmemory
          const response = await RecipeService.getFilteredData( dashboardName, columnsToRetrieve, columnNameToFilter, valueToMatch);
        
          if (response){
              setRecipeParameterListData(response.data); 
              const parameterNameList = response.data.map(item => item.ParameterName);
              setRecipeParameterList(parameterNameList); 
              //console.log(parameterNameList)

          }
  
        } catch (error) {
        console.log(error);
  
        }
      };
        getAllColumnData();
      
  
    }, []);

  // Get data from RecipeView for the selected Recipe
    useEffect(() =>{
      async function getAllColumnData()  {
        try {

          // Prepare API parameters
          const dashboardName = "RecipeView";
          const columnsToRetrieve = ["ParameterName"];
          const columnNameToFilter = "WidgetName";
          //const valueToMatch = recipeListData['recipegroupnamelist'];
          const valueToMatch = widgetName;
          //console.log(widgetName)
          

          // Fetch data from Inmemory
          const response = await RecipeService.getFilteredData( dashboardName, columnsToRetrieve, columnNameToFilter, valueToMatch);
        
          if (response.data){
              //const parameterNames = response.data.map(item => item.ParameterName);
              setParameterNames(response.data.map(item => item.ParameterName));

          }

        } catch (error) {
        console.log(error);

        }
      };
        getAllColumnData();
      

    }, []);


  const handleClose = () => {
    //console.log("Close Buton Pressed");
    close(); // Close the alarm add main window
  };

  const handleRecordSaveSuccess = (data) => {
    close(data);
  };

  const handleParameterSelection = (event) => {
    const { name, value } = event.target;

    setNewValues({ ...newValues, [name]: value });
    setSelectedParameter(value);

    // Find selected parameter record
    const selectedParameter = recipeParameterListData.find( item => item.ParameterName === value );

    if (selectedParameter) {
        if (parameterNames.includes(selectedParameter.ParameterName)) {
            // Parameter already exists
            alert("Duplicate Parameter, it is already present in recipe.");
        } else {
            // Keep only selected parameter record
            setRecipeParameterListData([selectedParameter]);
        }

    }
};


  const handleRemarkChange = (event) => {
    const { name, value } = event.target;
    if (configData.RemarkStatus === "Enabled") {
      setAuditTrailRemark(value);
    }
  };

  return (
    <div>
      <BootstrapDialog
        onClose={close}
        aria-labelledby="customized-dialog-title"
        open={open}
        PaperProps={{
          style: {
            maxWidth: "1000px", // Change this value as needed
          },
        }}
      >
        {/* Hnadle multiple functions on single click ie edit switch set to false and close the MyAccount Dialog */}
        <BootstrapDialogTitle
          id="customized-dialog-title"
          onClose={() => {
            handleClose();
          }}
        >
          Add Parameter to the Recipe.
        </BootstrapDialogTitle>

        {/*Tag Selection for the datalog */}
        <DialogContent dividers>
 
          {/* Parameter */}
          <FormControl sx={{ m: 0, width: 200, mt: 1 }}>
            <InputLabel shrink={false} sx={{ mt: -5, ml: "-14px" }}>
              Parameter Name
            </InputLabel>
            <Select
              name="ParameterName"
              value={selectedParameter}
              onChange={handleParameterSelection}
            >
              {recipeParameterList.map((name) => (
                <MenuItem key={name} value={name}>
                  {name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

        </DialogContent>

        {/*Remark */}
        {configData.RemarkStatus === "Enabled" && (
          <DialogContent dividers>
            <Typography gutterBottom sx={{ mt: 0, mb: 3, width: 400 }}>
              Enter remark/reason
            </Typography>

            <TextField
              id="outlined-multiline-static"
              label="Remark"
              name="Remark"
              placeholder="Enter Remark"
              multiline
              rows={2}
              style={{ width: 550 }}
              onChange={handleRemarkChange}
              //defaultValue="Default Value"
            />
          </DialogContent>
        )}

        <DialogActions>
          <SaveChangesDialog
            projectName={projectName}
            dashboardType={dashboardType}
            widgetName={widgetName}
            rowData={recipeParameterListData}
            configData={configData}
            email={user.email}
            role={user.role}
            oldValues={oldValues}
            newValues={newValues}
            activity={eventDescription}
            tagName={configData.TagName}
            auditTrailRemark={auditTrailRemark}
            success={handleRecordSaveSuccess}
          />
        </DialogActions>
      </BootstrapDialog>
    </div>
  );
}
